module.exports = __webpack_public_path__ + "media/images/spritesheet-2f26a57545f68fd28a108366182b011a.png";